export const StalkerModal = ({
  isOpen,
  onClose,
  followers = [],
}: {
  isOpen: boolean;
  onClose: () => void;
  followers: Array<{
    username: string;
    full_name: string;
    profile_pic_url: string;
    is_verified: boolean;
    is_private: boolean;
    latest_story_ts: number | null;
  }>;
}) => {
  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center ${
        isOpen ? "opacity-100 visible" : "opacity-0 invisible"
      } transition-all duration-300`}
      style={{ background: "rgba(0,0,0,0.85)" }}
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div
        className="modal-content bg-gray-900 rounded-xl p-6 shadow-2xl transform transition-transform duration-300 w-full mx-4 overflow-hidden"
        style={{ maxWidth: "550px", maxHeight: "90vh" }}
      >
        <div className="flex justify-between items-center mb-6 border-b border-gray-800 pb-4">
          <h1 className="text-2xl font-bold text-white">Seguidores</h1>
          <button
            className="text-gray-500 hover:text-white transition-colors p-2 hover:bg-gray-800 rounded-full"
            onClick={onClose}
            aria-label="Cerrar"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        <div className="mb-4">
          <input
            type="text"
            placeholder="Buscar seguidores..."
            className="w-full bg-gray-800 text-white border-0 rounded-lg px-4 py-3 outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div
          className="overflow-y-auto custom-scrollbar"
          style={{ maxHeight: "60vh" }}
        >
          <ul className="space-y-2">
            {followers.length > 0 ? (
              followers.map((follower, index) => (
                <li
                  key={index}
                  className="flex items-center justify-between p-3 hover:bg-gray-800 rounded-xl transition-colors"
                >
                  <div className="flex items-center">
                    <div className="relative">
                      <img
                        alt={follower.username}
                        className="rounded-full w-12 h-12 object-cover border border-gray-700"
                        src={follower.profile_pic_url}
                      />
                      {follower.latest_story_ts && (
                        <div
                          className="absolute inset-0 rounded-full border-2 border-pink-500"
                          style={{ padding: "2px" }}
                        ></div>
                      )}
                    </div>
                    <div className="ml-3">
                      <div className="flex items-center">
                        <span className="text-white font-medium">
                          {follower.full_name}
                        </span>
                        {follower.is_verified && (
                          <svg
                            className="ml-1 h-4 w-4 text-blue-500"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                          >
                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1.88 14.38L6.5 12.77l1.4-1.4 2.22 2.22 5.9-5.9 1.4 1.4-7.3 7.29z" />
                          </svg>
                        )}
                      </div>
                      <span className="text-gray-400 text-sm">
                        @{follower.username}
                      </span>
                    </div>
                  </div>
                  <div className="flex items-center">
                    {follower.is_private && (
                      <span className="mr-3">
                        <svg
                          className="h-4 w-4 text-gray-400"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <rect
                            x="3"
                            y="11"
                            width="18"
                            height="11"
                            rx="2"
                            ry="2"
                          />
                          <path d="M7 11V7a5 5 0 0110 0v4" />
                        </svg>
                      </span>
                    )}
                    <button className="text-blue-400 hover:text-blue-300 text-sm font-medium">
                      Ver perfil
                    </button>
                  </div>
                </li>
              ))
            ) : (
              <div className="text-center py-8 text-gray-400">
                <svg
                  className="mx-auto h-12 w-12 mb-4"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="12" cy="12" r="10" />
                  <line x1="12" y1="8" x2="12" y2="12" />
                  <line x1="12" y1="16" x2="12.01" y2="16" />
                </svg>
                <p>No se encontraron seguidores</p>
              </div>
            )}
          </ul>
        </div>

        <div className="mt-6 border-t border-gray-800 pt-4">
          <button className="w-full bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-500 hover:to-purple-500 text-white py-3 px-4 rounded-lg font-medium transition">
            Analizar Seguidores con IA Stalker
          </button>
        </div>

        <style>{`
          .custom-scrollbar::-webkit-scrollbar {
            width: 6px;
          }
          .custom-scrollbar::-webkit-scrollbar-track {
            background: #2D3748;
            border-radius: 10px;
          }
          .custom-scrollbar::-webkit-scrollbar-thumb {
            background: #4A5568;
            border-radius: 10px;
          }
          .custom-scrollbar::-webkit-scrollbar-thumb:hover {
            background: #718096;
          }
        `}</style>
      </div>
    </div>
  );
};
